// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__JIRAU","tab":"Tabs_tab__2H-V_","tabActive":"Tabs_tabActive__1xxnq"};